import {useState, createContext, useEffect } from "react";
import {Base64} from "../utils/helper.js";

const UserContext = createContext({
	userName : "",
	addUserName : (userName) => {},
	loggedInUserId : "",
	addLoggedInUserId : (loggedInUserId) => {},
	role : "",
	addRole : (role)  => {},
	isAuthenticated : false,
	addIsAuthenticated : (isAuthenticated)  => {},
	lastPingTime : "",
	addLastPingTime : (lastPingTime) => {},
	lang : "",
	addLang : (lang) => {},
	enabledMFA : 0,
	addEnabledMFA : (enabledMFA) => {},
	isSubscriptionValid: false,
	addIsSubscriptionValid : (isSubscriptionValid)  => {},
	tosTimeStamp : "",
	addTosTimeStamp : (tosTimeStamp) => {},
	clearStorage : ()  => {},
	});

export function UserContextProvider(props){
	
	const [userName, setUserName] = useState(getUserName());
	const [loggedInUserId, setLoggedInUserId] = useState(getLoggedInUserId());
	const [role, setRole] = useState(getRole());
	const [isAuthenticated, setIsAuthenticated] = useState(getIsAuthenticated());
	const [lastPingTime, setLastPingTime] = useState(getLastPingTime());
	const [lang, setLang] = useState(getLang());
	const [isSubscriptionValid, setIsSubscriptionValid] = useState(getIsSubscriptionValid());
	const [tosTimeStamp, setTosTimeStamp] = useState(getTosTimeStamp());
	const [enabledMFA, setEnabledMFA] = useState(getEnabledMFA());
	
	const context = {
		userName : userName,
		addUserName :  addUserName,
		loggedInUserId : loggedInUserId,
		addLoggedInUserId : addLoggedInUserId,
		role : role,
		addRole : addRole,
		isAuthenticated : isAuthenticated,
		addIsAuthenticated : addIsAuthenticated,
		lastPingTime : lastPingTime,
		addLastPingTime : addLastPingTime,
		clearStorage : clearStorage,
		lang : lang,
		addLang : addLang,
		isSubscriptionValid : isSubscriptionValid,
		addIsSubscriptionValid : addIsSubscriptionValid,
		tosTimeStamp : tosTimeStamp,
		addTosTimeStamp : addTosTimeStamp,
		enabledMFA : enabledMFA,
		addEnabledMFA : addEnabledMFA,
	};
	function clearStorage(){
	  localStorage.clear();
	}
	function getUserName() {
	  let itemKey = Base64.encode('userName');
      const userNameM = localStorage.getItem(itemKey);
      if(userNameM){
        let itemVal = Base64.decode(userNameM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
   function getLoggedInUserId() {
      let itemKey = Base64.encode('loggedInUserId');
      const loggedInUserIdM = localStorage.getItem(itemKey);
      if(loggedInUserIdM){
        let itemVal = Base64.decode(loggedInUserIdM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    function getRole() {
      let itemKey = Base64.encode('role');
      const roleM = localStorage.getItem(itemKey);
      if(roleM){
        let itemVal = Base64.decode(roleM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    
    function getIsAuthenticated() {
      let itemKey = Base64.encode('isAuthenticated');
      const isAuthenticatedM = localStorage.getItem(itemKey);
      if(isAuthenticatedM){
        let itemVal = Base64.decode(isAuthenticatedM);
        return (itemVal? itemVal : false);
      }
      return false;
    }
    
    function getEnabledMFA() {
      let itemKey = Base64.encode('enabledMFA');
      const enabledMFAM = localStorage.getItem(itemKey);
      if(enabledMFAM){
        let itemVal = Base64.decode(enabledMFAM);
        return (itemVal? itemVal : 0);
      }
      return 0;
    }
    function getLastPingTime() {
      let itemKey = Base64.encode('lastPingTime');
      const lastPingTimeM = localStorage.getItem(itemKey);
      if(lastPingTimeM){
        let itemVal = Base64.decode(lastPingTimeM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    
    function getLang() {
	  let itemKey = Base64.encode('lang');
      const langM = localStorage.getItem(itemKey);
      if(langM){
        let itemVal = Base64.decode(langM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
     
    function getIsSubscriptionValid() {
      let itemKey = Base64.encode('isSubscriptionValid');
      const isSubscriptionValidM = localStorage.getItem(itemKey);
      if(isSubscriptionValidM){
        let itemVal = Base64.decode(isSubscriptionValidM);
        return (itemVal? itemVal : false);
      }
      return false;
    }
    function getTosTimeStamp() {
	  let itemKey = Base64.encode('tosTimeStamp');
      const tosTimeStampM = localStorage.getItem(itemKey);
      if(tosTimeStampM){
        let itemVal = Base64.decode(tosTimeStampM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    useEffect(() => {
      if(userName){
        let itemKey = Base64.encode('userName');
        let itemVal = Base64.encode(userName);
        localStorage.setItem(itemKey, itemVal);
      }     
    }, [userName]);
  
    useEffect(() => {
       if(loggedInUserId){
          let itemKey = Base64.encode('loggedInUserId');
          let itemVal = Base64.encode(loggedInUserId);
          localStorage.setItem(itemKey, itemVal);
       } 
    }, [loggedInUserId]);
    
    useEffect(() => {
       if(role){
          let itemKey = Base64.encode('role');
          let itemVal = Base64.encode(role);
          localStorage.setItem(itemKey, itemVal);
       } 
       
    }, [role]);
    
    useEffect(() => {
       if(isAuthenticated !== null){
          let itemKey = Base64.encode('isAuthenticated');
          let itemVal = Base64.encode(""+isAuthenticated);
          localStorage.setItem(itemKey, itemVal);
       } 
       
    }, [isAuthenticated]);
    
    useEffect(() => {
		if(lastPingTime){
			let itemKey = Base64.encode('lastPingTime');
			let itemVal = Base64.encode(""+lastPingTime);
			localStorage.setItem(itemKey, itemVal);
		}
	}, [lastPingTime]);
	
	useEffect(() => {
       if(enabledMFA !== null){
          let itemKey = Base64.encode('enabledMFA');
          let itemVal = Base64.encode(""+enabledMFA);
          localStorage.setItem(itemKey, itemVal);
       } 
       
    }, [enabledMFA]);
    
    useEffect(() => {
      if(lang){
        let itemKey = Base64.encode('lang');
        let itemVal = Base64.encode(lang);
        localStorage.setItem(itemKey, itemVal);
      }     
    }, [lang]);
    
    useEffect(() => {
      if(isSubscriptionValid){
        let itemKey = Base64.encode('isSubscriptionValid');
        let itemVal = Base64.encode(""+isSubscriptionValid);
        localStorage.setItem(itemKey, itemVal);
      }     
    }, [isSubscriptionValid]);
    
    useEffect(() => {
      if(tosTimeStamp){
        let itemKey = Base64.encode('tosTimeStamp');
        let itemVal = Base64.encode(tosTimeStamp);
        localStorage.setItem(itemKey, itemVal);
      }     
    }, [tosTimeStamp]);
    
	function addUserName(userName){
		setUserName(userName);
	}
	function addLoggedInUserId(loggedInUserId){
		setLoggedInUserId(loggedInUserId);
	}
	function addRole(role){
		setRole(role);
	}
	function addIsAuthenticated(isAuthenticated){
		setIsAuthenticated(isAuthenticated);
	}
	function addLang(lang){
		setLang(lang);
	}
	function addLastPingTime(lastPingTime){
		setLastPingTime(lastPingTime);
	}
	function addIsSubscriptionValid(isSubscriptionValid){
		setIsSubscriptionValid(isSubscriptionValid);
	}
	function addTosTimeStamp(tosTimeStamp){
		setTosTimeStamp(tosTimeStamp);
	}
	function addEnabledMFA(enabledMFA){
		setEnabledMFA(enabledMFA);
	}
	return <UserContext.Provider value ={context}>
	{props.children}
	</UserContext.Provider>;
}

export default UserContext;